import React from "react";
import "./CBAFooter.css";
import { Link } from "react-router-dom";
import { useWhitelabel } from "../../context/WhitelabelContext"; // Import our new hook! Adjust path as needed

const CONTACT_PAGE = "/contact";
const LOGIN_PAGE = "/signin";
const SIGNUP_PAGE = "/accounts/signup";
const ABOUT_PAGE = "/about";
const EMPLOYERS_PAGE = "/employers";
const EMPLOYEES_PAGE = "/employees";
const PRICING_PAGE = "/pricing";
const BLOG_PAGE = "/blogs";
const PRIVACY_POLICY_PAGE = "/privacy";
const TERMS_CONDITIONS_PAGE = "/terms";

function CBAFooter() {
  const { logoSrc } = useWhitelabel();

    // --- Styles (Patricia's Bright & Beautiful Makeover! ✨) ---
    const styles: { [key: string]: React.CSSProperties } = {
        container: {
            fontFamily: "'DM Sans', sans-serif",
            backgroundColor: "#FFFFFF",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
        },
        card: {
            background: "#FFFFFF",
            borderRadius: "16px",
            padding: "40px",
            width: "100%",
            maxWidth: "480px",
            border: "1px solid #E0E0E0",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.05)",
            textAlign: "center",
        },
        logo: {
            cursor: "pointer",
            height: "40px",
            marginBottom: "24px",
        },
        title: {
            fontFamily: "'Urbanist', sans-serif",
            fontWeight: 700,
            fontSize: "28px",
            lineHeight: 1.2,
            marginBottom: "8px",
            color: "#141414",
        },
        subtitle: {
            fontSize: "16px",
            color: "#555555",
            marginBottom: "32px",
        },
        formGroup: {
            marginBottom: "20px",
            position: "relative",
            textAlign: "left",
        },
        label: {
            display: 'block',
            fontWeight: 500,
            fontSize: '14px',
            color: '#242424',
            marginBottom: '8px',
        },
        input: {
            width: "100%",
            padding: "12px 45px 12px 16px",
            backgroundColor: "#F8F9FA",
            border: "1px solid #D1D1D1",
            borderRadius: "8px",
            color: "#242424",
            fontSize: "16px",
            outline: "none",
            transition: "border-color 0.3s ease, box-shadow 0.3s ease",
        },
        inputError: {
            borderColor: "#dc3545",
        },
        inputIcon: {
            position: "absolute",
            right: "15px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
        },
        forgotPasswordLink: {
            display: "block",
            textAlign: "right",
            fontSize: "14px",
            color: "#0065FF",
            textDecoration: "none",
            marginTop: "-10px",
            marginBottom: "24px",
        },
        button: {
            background: "#0065FF",
            borderRadius: "8px",
            border: "none",
            boxShadow: "0px 10px 20px -10px rgba(0, 101, 255, 0.4)",
            padding: "16px",
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 700,
            fontSize: "16px",
            color: "#FFFFFF",
            cursor: "pointer",
            width: "100%",
            transition: "all 0.3s ease",
        },
        buttonDisabled: {
            opacity: 0.6,
            cursor: "not-allowed",
        },
        footerText: {
            marginTop: "24px",
            fontSize: "14px",
            color: "#555555"
        },
        footerLink: {
            color: "#0065FF",
            fontWeight: 700,
            textDecoration: "none",
        }
    };


  return (
    <footer className="cba-footer-section">
      <div className="container-fluid cba-footer-content-wrap">
        <div className="row cba-footer-top">
          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 cba-footer-left">
              <div style={styles.logo}>
                {logoSrc && <img src={logoSrc} style={styles.logo} alt="logo" />}
              </div>
          </div>

          <div className="col-lg-3 col-md-6 cba-footer-right">
            <div className="cba-footer-links">
              <Link to={LOGIN_PAGE}>Login</Link>
              <Link to={SIGNUP_PAGE}>Signup</Link>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 cba-footer-right">
            <div className="cba-footer-links">
            </div>
          </div>
          <div className="cba-footer-terms-mob">
          </div>
          <div className="cba-social-icons">
          </div>
        </div>
        <div className="cba-border-footer"></div>
        <div className="cba-footer-bottom">
          {/* <p>© 2025</p> */}
          <div className="cba-footer-terms">
          </div>
        </div>
      </div>
    </footer>
  );
}

export default CBAFooter;
